import React from 'react';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

const TextWithTooltip = ({
  text,
  tooltip,
  onClick,
  ariaLabel,
  target,
  children,
  position,
  delayShow,
  tooltipElement,
  toolTipElementProps,
  ...otherProps
}) => {
  const ToolTipElement = ({ children: toolTipChildren, ...oProps }) =>
    React.createElement(tooltipElement, oProps, toolTipChildren);

  // Pass a11y props to children element/s, not to the tooltipElement
  // This helps cases where the Icon should receive a11y props
  let ChildrenWrapper = text || children;
  const accessibility = {
    ariaLabel: ariaLabel || tooltip,
    tabIndex: 0,
  };
  if (ChildrenWrapper && React.isValidElement(ChildrenWrapper)) {
    ChildrenWrapper = React.cloneElement(ChildrenWrapper, { accessibility });
  }

  return (
    <Tooltip
      target={target}
      description={tooltip}
      position={position}
      delayShow={delayShow}
      {...otherProps}
    >
      <ToolTipElement
        aria-label={ariaLabel || text}
        data-for={target}
        data-tip={tooltip}
        onClick={onClick}
        className={cn({
          'cursor-pointer hover:underline': onClick,
        })}
        {...toolTipElementProps}
        {...(!React.isValidElement(ChildrenWrapper) ? accessibility : {})}
      >
        {ChildrenWrapper}
      </ToolTipElement>
    </Tooltip>
  );
};

TextWithTooltip.propTypes = {
  text: PropTypes.string,
  tooltip: PropTypes.string,
  position: PropTypes.string,
  tooltipElement: PropTypes.string,
  toolTipElementProps: PropTypes.object,
};

TextWithTooltip.defaultProps = {
  text: '',
  tooltip: '',
  position: 'top',
  tooltipElement: 'span',
  toolTipElementProps: {},
};

export default TextWithTooltip;
